import React, { useState, useEffect } from "react";
import { Badge, Button, Col, Form, Row } from "react-bootstrap";
import rightArrow from "../../assets/images/icons/rightArrow.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Y_Us_StripComponent from "../common/Y_us_strip";
import explore_products_1 from "../../assets/images/dummy/explore_products_1.png";
import Constants from "../Variables/Constants";
import { toast } from "react-toastify";
import axios from "axios";
import ReactPaginate from "react-paginate";
import qs from "qs";
import Product from "./Product";
import { useDispatch } from "react-redux";
import { setCartItems } from "../../redux/cartSlice";
import { matchingData } from "../../utils";

const ProductsDetailsPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const categoryId = location.search.split("&")[0].split("=").at(-1);
  const collectionId = location.search.split("&")[1].split("=").at(-1);
  const productId = location.search.split("&")[2].split("=").at(-1);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [productList, setProductList] = useState([]);
  const [quantityNumber, setQuantityNumber] = useState(1);
  const [product, setProduct] = useState("");
  const [flag, setFlag] = useState(false);
  const [categoryData, setCategoryData] = useState("");
  const [collectionData, setCollectionData] = useState("");
  const [mainFabricData, setMainFabricData] = useState("");
  const [sizeData, setSizeData] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedMatchingSize, setSelectedMatchingSize] = useState(matchingData[0]);
  const [isMatchingShow, setIsMatchingShow] = useState(false);

  // console.log("product", product);
  // console.log("sizeData", sizeData);
  // console.log("selectedSize", selectedSize);
  // console.log("mainFabricData", mainFabricData)
  // console.log("selectedMatchingSize", selectedMatchingSize)
  // const [searchPayload, setSearchPayload] = useState({
  //   search: "",
  //   sortBy: "",
  //   startDate: "",
  //   endDate: "",
  // });

  useEffect(() => {
    if (matchingData && matchingData.length > 0 && selectedSize && selectedSize?.size_name && (selectedSize?.size_name?.toLowerCase()?.includes("xl") || selectedSize?.size_name?.toLowerCase()?.includes("large") || selectedSize?.size_name?.toLowerCase()?.includes("extra large"))) {
      setIsMatchingShow(true);
    } else {
      setIsMatchingShow(false);
      setSelectedMatchingSize(matchingData[0]);
    }
  }, [selectedSize]);


  const handleSizeData = async ({ sizeIds, mainFabricData }) => {
    try {
      const response = await axios.post(
        Constants.postUrls.getMultipleSize,
        sizeIds
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        if (data.length > 0) {
          setSizeData(data);

          const sizeItem = data.find(
            (io) => io?._id === product?.size_id?._id
          );

          const price = mainFabricData?.size_details?.find(
            (io) => io?.size_id === product?.size_id?._id
          )?.price;

          setSelectedSize({ ...sizeItem, price });
        } else {
          setSizeData([]);
        }
        // setLoader(false);
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response.data.message);
        // setLoader(false);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const getFabricData = async (main_fabric_id) => {
    try {
      const resp = await axios.get(
        `${Constants.getUrls.getSingleFabric}/${main_fabric_id}`, { headers: { Authorization: token } },
      );
      if (resp.data.status === "success") {
        const data = resp.data.data;
        if (data) {
          setMainFabricData(data)
          if (data?.size_details) {
            const sizeIds = data?.size_details.map((io) => io.size_id);
            if (Array.isArray(sizeIds) && sizeIds.length > 0) {
              handleSizeData({ sizeIds, mainFabricData: data });
            }
          }
        }

      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(resp.data.message);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    if (product) {
      if (product?.size_id?._id) {
        getFabricData(product?.main_fabric_id?._id);
      }

      if (product?.matching_bag) {
        const parseMatchingBag = JSON.parse(product?.matching_bag);
        setSelectedMatchingSize(matchingData.find(io => io.name === parseMatchingBag.name));
      }
    }
  }, [product])


  const getCategoryDetail = async () => {
    if (!categoryId || categoryId === "undefined") {
      setCategoryData("");
      return;
    }
    try {
      const resp = await axios.get(
        `${Constants.getUrls.getAllCategory}/${categoryId}`
      );
      if (resp.data.status === "success") {
        setCategoryData(resp?.data?.data);
      }
    } catch (error) {
      try {
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        // Silently handle category not found errors
      }
    }
  };

  const getCollectionDetail = async () => {
    if (!collectionId || collectionId === "undefined") {
      setCollectionData("");
      return;
    }
    try {
      const resp = await axios.get(
        `${Constants.getUrls.getAllCollections}/${collectionId}`
      );
      if (resp.data.status === "success") {
        setCollectionData(resp.data.data);
      }
    } catch (error) {
      try {
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        // Silently handle collection not found errors
      }
    }
  };

  const getSingleProduct = () => {
    try {
      axios
        .get(Constants.getUrls.getProduct + "/" + productId)
        .then((resp) => {
          if (resp.data.status === "success") {
            if (resp.data.data) {
              setProduct(resp.data.data);
            } else {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.error(resp.data.message);
              setProduct("");
            }
          } else {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(resp.data.message);
          }
        })
        .catch((error) => {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error("Something went wrong", error.message);
        });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    if (productId && categoryId && collectionId) {
      getSingleProduct();
      getCategoryDetail();
      getCollectionDetail();
    }
  }, [productId, categoryId, collectionId, flag]);

  const fetchCart = async () => {
    try {
      const res = await axios.get(Constants.getUrls.getCart, {
        headers: { Authorization: token },
      });
      if (res.data.status === "success") {
        const data = res.data.data.docs;
        const arr = [];
        if (data && Array.isArray(data) && data.length > 0) {
          data.map((item) => {
            arr.push({
              _id: item._id,
              product_id: item.product_id._id,
              images: item.product_id.images,
              name: item.product_id.name,
              price: item.product_id.price,
              quantity: item.quantity,
            });
          });
          dispatch(setCartItems(arr));
          localStorage.removeItem("cart");
        } else {
          dispatch(setCartItems([]));
          localStorage.removeItem("cart");
        }
      } else {
        dispatch(setCartItems([]));
        localStorage.removeItem("cart");
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleUpdateProduct = async () => {
    try {

      const existMatchingBagPrice = product.matching_bag ? JSON.parse(product.matching_bag).price : 0
      const existingSizePrice = product.size_id?._id ? mainFabricData.size_details.find(io => io.size_id === product.size_id._id).price : 0
      const deductExistingPrice = product.price - (existMatchingBagPrice + existingSizePrice)
      const totalPrice = (deductExistingPrice || 0) + (selectedSize.price || 0) + (selectedMatchingSize.price || 0)
      // console.log("selectedSize", selectedSize)
      // console.log('selectedMatchingSize', selectedMatchingSize)
      // console.log("existingSizePrice", existingSizePrice)
      // console.log("existMatchingBagPrice", existMatchingBagPrice)
      // console.log("existingPrice", product.price)
      // console.log("deductExistingPrice", deductExistingPrice)
      // console.log("totalPrice", totalPrice)

      // const formData = new FormData();
      // formData.append("size_id", selectedSize._id);
      // formData.append("matching_bag", JSON.stringify({ name: selectedMatchingSize.name, price: selectedMatchingSize.price }));
      // formData.append("price", totalPrice);
      // formData.append("offer_price", totalPrice);
      const payload = {
        size_id: selectedSize._id,
        matching_bag: JSON.stringify({ name: selectedMatchingSize.name, price: selectedMatchingSize.price }),
        price: totalPrice,
        offer_price: totalPrice,
      }

      const response = await axios.put(
        Constants.putUrls.updateSingleProduct + "/" + product._id,
        // formData,
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );

    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }

  }

  const handleAddToCart = () => {
    try {

      if (!token) {
        const localCart = localStorage.getItem("cart");
        const obj = { _id: product._id, quantity: 1 };
        if (localCart) {
          const cartLocalData = JSON.parse(localCart);
          if (cartLocalData && Array.isArray(cartLocalData)) {
            const existingProduct = cartLocalData.filter(
              (io) => io._id === obj._id
            );
            if (existingProduct.length > 0) {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.error("Product Already In Cart!");
              return;
            }
            const data = [...JSON.parse(localCart), obj];
            localStorage.setItem("cart", JSON.stringify(data));
            dispatch(setCartItems(data));
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success("Product Added To Cart!");
            return;
          } else {
            const data = [obj];
            localStorage.setItem("cart", JSON.stringify(data));
            dispatch(setCartItems(data));
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success("Product Added To Cart!");
            return;
          }
        } else {
          const data = [obj];
          localStorage.setItem("cart", JSON.stringify(data));
          dispatch(setCartItems(data));
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.success("Product Added To Cart!");
          return;
        }
      } else {
        handleUpdateProduct();
        axios
          .post(
            Constants.postUrls.AddToCart,
            {
              product_id: product._id,
              quantity: quantityNumber,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          )
          .then((resp) => {
            if (resp.data.status === "success") {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.success("Product added to cart successfully!");
              fetchCart();
            } else {
              toast.clearWaitingQueue();
              toast.dismiss();
              toast.error(resp.data.message);
            }
          })
          .catch((error) => {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(error.message);
          });
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const handleHeartToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      axios
        .put(
          `${Constants.getUrls.toggleProduct}/${product?._id}`,
          {
            is_favourite: product?.is_favourite === "yes" ? "no" : "yes",
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((resp) => {
          if (resp.status === 200) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success(
              product.is_favourite === "yes"
                ? "Product removed from favourites!"
                : "Product added to favourites!"
            );
          } else {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(resp.data.message);
          }
          setFlag(!flag);
        })
        .catch((error) => {
          setFlag(!flag);
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error("Something went wrong", error.message);
        });
    } catch (error) {
      try {
        setFlag(!flag);
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  return (
    <div className="container-fluid px-5">
      <nav className="my-5 font-poppins route-navigation">
        <ul className="d-flex flex-wrap gap-4 text-light-gray fs-20 fw-bold">
          <li className="list-unstyled">
            <Link to="/" className="text-decoration-none ">
              HOME
            </Link>
          </li>
          <li className="list-unstyled">
            <img loading="lazy"  src={rightArrow} alt="arrow" />
          </li>
          <NavLink to={`/category?catid=${categoryData?._id}`}>
            <li className="list-unstyled">{categoryData?.title}</li>
          </NavLink>

          <li className="list-unstyled">
            <img loading="lazy"  src={rightArrow} alt="" />
          </li>
          <NavLink
            to={`/category/collection?catid=${categoryData?._id}&collectionId=${collectionData?._id}`}
          >
            <li className="list-unstyled">{collectionData?.title}</li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy"  src={rightArrow} alt="arrow" />
          </li>
          <NavLink
            to={`/category/collection/product-detail?catid=${categoryData?._id}&collectionId=${collectionData?._id}&productId=${product?._id}`}
          >
            <li className="list-unstyled text-dark">{product?.name}</li>
          </NavLink>
        </ul>
      </nav>

      <div className="row">
        <div className="col-md-6 col-12 col-xl-4">
          <div className="prodImg w-100 position-relative">
            {product?.images && (
              <img loading="lazy" 
                className="w-100"
                src={Constants.imgDomain + product?.images[0]}
                alt=""
              />
            )}
            {/* <span className="badge fs-14 text-white position-absolute posi1 text-bg-warning">
              New
            </span> */}
            {/* <span className="badge fs-14 position-absolute posi2 text-white text-bg-success">
              -70%
            </span> */}
          </div>
          <div className="mt-4 d-flex gap-2 align-items-center ">
            <div className="quentity flex-grow-1 d-flex align-items-center gap-2">
              <button
                className=" rounded-3 fs-22 border-none"
                type="button"
                onClick={() => {
                  if (quantityNumber > 1) {
                    setQuantityNumber(quantityNumber - 1);
                  }
                }}
              >
                -
              </button>
              <div className="count w-75 text-center d-flex align-items-center justify-content-center border rounded-4 fs-30 text-muted">
                {quantityNumber}
              </div>
              <button
                className=" rounded-3 text-white fs-22   border-none bg-blue "
                type="button"
                onClick={() => {
                  setQuantityNumber(quantityNumber + 1);
                }}
              >
                +
              </button>
            </div>

            <button
              className=" rounded-3 fs-16 py-3 px-5 border-none "
              type="button"
              onClick={() => handleAddToCart()}
            >
              <img loading="lazy"  src="/cart.png" alt="" className="me-3" /> Add To Cart
            </button>
            <button className=" rounded-3 fs-16 px-3 py-3 h-100 border bg-white ">
              <div
                className="badges_icons"
                onClick={(e) => handleHeartToggle(e)}
              >
                {product?.is_favourite === "no" || !product?.is_favourite ? (
                  <i
                    className="mt-1 bi bi-heart px-2"
                    style={{ color: "grey" }}
                  ></i>
                ) : (
                  <i
                    className="mt-1 bi bi-heart-fill px-2"
                    style={{ color: "red" }}
                  ></i>
                )}
              </div>
            </button>
          </div>
        </div>
        <div className="col-md-6 col-12 col-xl-8">
          <div className="details mt-4 mt-lg-0 text-color p-4 bg-light-gray rounded-3">
            <h2 className="fs-30">{product?.name}</h2>

            <p className="fs-20">{product?.description}</p>

            <h3>Price: ${product?.price}</h3>

            {sizeData && sizeData.length > 0 && (
              <>
                <p className="fw-semibold fs-16 my-4">Choose Your Bag Size:</p>

                <div className="size-selection-container p-0">
                  <div className="size-options-grid gap-0">
                    {sizeData.map((item, index) => (
                      <div
                        key={item._id}
                        className={`size-option m-2 ${selectedSize && selectedSize._id === item._id ? "selected" : ""
                          }`}
                        onClick={() => {
                          setSelectedSize({
                            ...item,
                            price: mainFabricData.size_details.find(
                              (io) => io.size_id === item._id
                            )?.price,
                          });
                        }}
                      >
                        <div
                          className={`size-name ${selectedSize && selectedSize._id === item._id ? "selected" : ""
                            }`}
                        >
                          {item?.size_name} ({item?.size_code} {item?.dimensions?.width}"{" X "}
                          {item?.dimensions?.height}")
                        </div>
                        <div
                          className={`size-price ${selectedSize && selectedSize._id === item._id ? "selected" : ""
                            }`}
                        >
                          $
                          {
                            mainFabricData.size_details.find(
                              (io) => io.size_id === item._id
                            )?.price
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>)}

            {isMatchingShow && (
              <>
                <div className="size-selection-container p-0">
                  <Form.Label className="size-selection-label">
                    Choose Matching Size:
                  </Form.Label>
                  <div className="size-options-grid">
                    {matchingData.map((item, index) => (
                      <div
                        key={index}
                        className={`size-option m-0 ${selectedMatchingSize && selectedMatchingSize.id === item.id ? "selected" : ""
                          }`}
                        onClick={() => {
                          setSelectedMatchingSize(item);
                        }}
                      >
                        <div
                          className={`size-name ${selectedMatchingSize && selectedMatchingSize.id === item.id ? "selected" : ""
                            }`}
                        >
                          {item.name}
                        </div>
                        <div
                          className={`size-price ${selectedMatchingSize && selectedMatchingSize.id === item.id ? "selected" : ""
                            }`}
                        >
                          ${item.price}
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </>)}

            {/* <>
              <div
                style={{ backgroundColor: "#E8E9ED", borderRadius: "10px" }}
              >
                {product &&
                  Object.keys(product) &&
                  Object.keys(product).length > 0 ? (
                  <>
                    <Form.Label
                      style={{
                        fontSize: "20px",
                        fontWeight: "500",
                        marginBottom: "10px",
                        marginTop: "10px",
                      }}
                    >
                      Choose Your Bag Size:
                    </Form.Label>
                    <div className="d-flex">
                      {product.variant.map((item, index) => {
                        return (
                          <div
                            style={{
                              padding: "20px",
                              margin: "10px",
                              backgroundColor:
                                selectedSize && selectedSize._id === item._id
                                  ? "#1C274C"
                                  : "#ffffff",
                              minWidth: "fit-content",
                              maxWidth: "fit-content",
                              height: "80px",
                              borderRadius: "10px",
                              cursor: "pointer",
                            }}
                            key={index + 1}
                            onClick={() => {
                              setSelectedSize(item);
                            }}
                          >
                            <div
                              style={{
                                fontSize: "15px",
                                color:
                                  selectedSize && selectedSize._id === item._id
                                    ? "#ffffff"
                                    : "#000000",
                                position: "relative",
                                top: "-8px",
                              }}
                            >
                              {product?.name} ({item?.size}{" "}
                              {item?.offer_price} x {item?.quantity})
                            </div>
                            <div
                              style={{
                                color:
                                  selectedSize && selectedSize._id === item._id
                                    ? "#D9D9D9"
                                    : "#8a8a8a",
                                fontSize: "14px",
                                position: "relative",
                                top: "8px",
                              }}
                            >
                              ${item?.offer_price}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: "600",
                        height: "100px",
                      }}
                    >
                      No Sizes Available
                    </div>
                  </>
                )}
              </div>
            </> */}

            {/* <div className="row g-4">
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border position-relative p-4 fs-16 rounded-5 text-white bg-blue">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>
                  <span className="badge p-3 fs-14 position-absolute posi3 text-white text-bg-success">
                    -70%
                  </span>
                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border p-4 fs-16 rounded-5 text-black bg-white">
                  <p>Large Talis Bag (14" x 14")</p>

                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border p-4 fs-16 position-relative rounded-5 text-black bg-white">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>
                  <span className="badge p-3 fs-14 position-absolute posi3 text-white text-bg-success">
                    -70%
                  </span>
                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border position-relative p-4 fs-16 rounded-5 text-black bg-white">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>

                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border p-4 fs-16 rounded-5 text-black bg-white">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>

                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>

                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <p className="fw-semibold fs-16 my-4">Add matching bag:</p>
            <div className="row g-4">
              <div className="col-xl-2 col-md-4 col-6">
                <div className="border h-100 px-5 d-flex justify-content-center align-items-center position-relative p-4 fs-16 rounded-5 text-white bg-blue">
                  <p>None</p>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border p-4 fs-16 rounded-5 text-black bg-white">
                  <p>Large Talis Bag (14" x 14")</p>

                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border p-4 fs-16 position-relative rounded-5 text-black bg-white">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>
                  <span className="badge p-3 fs-14 position-absolute posi3 text-white text-bg-success">
                    -70%
                  </span>
                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border position-relative p-4 fs-16 rounded-5 text-black bg-white">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>

                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6 col-6">
                <div className="bagCard border p-4 fs-16 rounded-5 text-black bg-white">
                  <p>Bar Mitzvah Bag (BMX 10.5" x 10")</p>

                  <div className="d-flex gap-3">
                    <p className="text-decoration-line-through text-secondary fw-semibold">
                      $50
                    </p>
                    <p className="text-orange">$30</p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>{" "}
        </div>
      </div>
      {/* {productList.length > 1 && (
        <>
          <h1 className="mt-5 mb-4">Similar Products</h1>

          <Row className="g-4 mt-2">
            {productList.map(
              (product, index) =>
                product._id !== productId && (
                  <Col sm="6" lg="3" key={product._id}>
                    <Product
                      product={product}
                      flag={flag}
                      setFlag={setFlag}
                      categoryId={categoryId}
                      collectionId={collectionId}
                    />
                  </Col>
                )
            )}
          </Row>
        </>
      )} */}

      {/* {productList.length > 1 && (
        <>
          <Row>
            <Col md={12} className="d-flex justify-content-center">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </Col>
          </Row>
        </>
      )} */}

      <Y_Us_StripComponent />
    </div>
  );
};

export default ProductsDetailsPage;
